/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  EnumValuePageDto,
  EquipmentPageDto,
  VehicleModelPageDto
} from '../../models';

import { customInstance } from '../../../../custom-instance';
import type { ErrorType } from '../../../../custom-instance';




/**
 * Returns the body styles a vehicle can have. Localized: each value carries a 'translation' in the language of the Accept-Language header, falling back to null when the translation service has no entry for it. A translation outage degrades to untranslated values rather than failing the request.
 * @summary List vehicle body styles
 */
export const getBodyStyles = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<EnumValuePageDto>(
      {url: `/fleet/reference/v1/body-styles`, method: 'GET', signal
    },
      );
    }
  

export const getGetBodyStylesQueryKey = () => {
    return [`/fleet/reference/v1/body-styles`] as const;
    }

    
export const getGetBodyStylesQueryOptions = <TData = Awaited<ReturnType<typeof getBodyStyles>>, TError = ErrorType<null | null | null>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBodyStyles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBodyStylesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBodyStyles>>> = ({ signal }) => getBodyStyles(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBodyStyles>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBodyStylesQueryResult = NonNullable<Awaited<ReturnType<typeof getBodyStyles>>>
export type GetBodyStylesQueryError = ErrorType<null | null | null>


export function useGetBodyStyles<TData = Awaited<ReturnType<typeof getBodyStyles>>, TError = ErrorType<null | null | null>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBodyStyles>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBodyStyles>>,
          TError,
          Awaited<ReturnType<typeof getBodyStyles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBodyStyles<TData = Awaited<ReturnType<typeof getBodyStyles>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBodyStyles>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBodyStyles>>,
          TError,
          Awaited<ReturnType<typeof getBodyStyles>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBodyStyles<TData = Awaited<ReturnType<typeof getBodyStyles>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBodyStyles>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List vehicle body styles
 */

export function useGetBodyStyles<TData = Awaited<ReturnType<typeof getBodyStyles>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBodyStyles>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBodyStylesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns the colors a vehicle can have. Localized on the same terms as body styles.
 * @summary List vehicle colors
 */
export const getColors = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<EnumValuePageDto>(
      {url: `/fleet/reference/v1/colors`, method: 'GET', signal
    },
      );
    }
  

export const getGetColorsQueryKey = () => {
    return [`/fleet/reference/v1/colors`] as const;
    }

    
export const getGetColorsQueryOptions = <TData = Awaited<ReturnType<typeof getColors>>, TError = ErrorType<null | null | null>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetColorsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getColors>>> = ({ signal }) => getColors(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetColorsQueryResult = NonNullable<Awaited<ReturnType<typeof getColors>>>
export type GetColorsQueryError = ErrorType<null | null | null>


export function useGetColors<TData = Awaited<ReturnType<typeof getColors>>, TError = ErrorType<null | null | null>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getColors>>,
          TError,
          Awaited<ReturnType<typeof getColors>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetColors<TData = Awaited<ReturnType<typeof getColors>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getColors>>,
          TError,
          Awaited<ReturnType<typeof getColors>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetColors<TData = Awaited<ReturnType<typeof getColors>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List vehicle colors
 */

export function useGetColors<TData = Awaited<ReturnType<typeof getColors>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getColors>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetColorsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns the equipment items a vehicle can carry, each optionally grouped under a category so the equipment picker can be rendered in sections. Not localized on this surface.
 * @summary List vehicle equipment
 */
export const getEquipment = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<EquipmentPageDto>(
      {url: `/fleet/reference/v1/equipment`, method: 'GET', signal
    },
      );
    }
  

export const getGetEquipmentQueryKey = () => {
    return [`/fleet/reference/v1/equipment`] as const;
    }

    
export const getGetEquipmentQueryOptions = <TData = Awaited<ReturnType<typeof getEquipment>>, TError = ErrorType<null | null | null>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquipment>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEquipmentQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEquipment>>> = ({ signal }) => getEquipment(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEquipment>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEquipmentQueryResult = NonNullable<Awaited<ReturnType<typeof getEquipment>>>
export type GetEquipmentQueryError = ErrorType<null | null | null>


export function useGetEquipment<TData = Awaited<ReturnType<typeof getEquipment>>, TError = ErrorType<null | null | null>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquipment>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquipment>>,
          TError,
          Awaited<ReturnType<typeof getEquipment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquipment<TData = Awaited<ReturnType<typeof getEquipment>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquipment>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEquipment>>,
          TError,
          Awaited<ReturnType<typeof getEquipment>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEquipment<TData = Awaited<ReturnType<typeof getEquipment>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquipment>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List vehicle equipment
 */

export function useGetEquipment<TData = Awaited<ReturnType<typeof getEquipment>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEquipment>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEquipmentQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns the intents (trip purposes) a booking can be tagged with. Used both as a scheduler filter and as a vehicle-form field. Not localized on this surface.
 * @summary List booking intents
 */
export const getIntents = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<EnumValuePageDto>(
      {url: `/fleet/reference/v1/intents`, method: 'GET', signal
    },
      );
    }
  

export const getGetIntentsQueryKey = () => {
    return [`/fleet/reference/v1/intents`] as const;
    }

    
export const getGetIntentsQueryOptions = <TData = Awaited<ReturnType<typeof getIntents>>, TError = ErrorType<null | null | null>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntentsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntents>>> = ({ signal }) => getIntents(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntentsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntents>>>
export type GetIntentsQueryError = ErrorType<null | null | null>


export function useGetIntents<TData = Awaited<ReturnType<typeof getIntents>>, TError = ErrorType<null | null | null>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntents>>,
          TError,
          Awaited<ReturnType<typeof getIntents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntents<TData = Awaited<ReturnType<typeof getIntents>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntents>>,
          TError,
          Awaited<ReturnType<typeof getIntents>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntents<TData = Awaited<ReturnType<typeof getIntents>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntents>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List booking intents
 */

export function useGetIntents<TData = Awaited<ReturnType<typeof getIntents>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntents>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntentsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Returns every known vehicle model with its brand. The booking engine caches this list, so it is cheap to call and safe to cache client-side for the length of a session. Not localized — model names are proper nouns.
 * @summary List vehicle models
 */
export const getVehicleModels = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<VehicleModelPageDto>(
      {url: `/fleet/reference/v1/vehicle-models`, method: 'GET', signal
    },
      );
    }
  

export const getGetVehicleModelsQueryKey = () => {
    return [`/fleet/reference/v1/vehicle-models`] as const;
    }

    
export const getGetVehicleModelsQueryOptions = <TData = Awaited<ReturnType<typeof getVehicleModels>>, TError = ErrorType<null | null | null>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleModels>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehicleModelsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicleModels>>> = ({ signal }) => getVehicleModels(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVehicleModels>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehicleModelsQueryResult = NonNullable<Awaited<ReturnType<typeof getVehicleModels>>>
export type GetVehicleModelsQueryError = ErrorType<null | null | null>


export function useGetVehicleModels<TData = Awaited<ReturnType<typeof getVehicleModels>>, TError = ErrorType<null | null | null>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleModels>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleModels>>,
          TError,
          Awaited<ReturnType<typeof getVehicleModels>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleModels<TData = Awaited<ReturnType<typeof getVehicleModels>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleModels>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleModels>>,
          TError,
          Awaited<ReturnType<typeof getVehicleModels>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleModels<TData = Awaited<ReturnType<typeof getVehicleModels>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleModels>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List vehicle models
 */

export function useGetVehicleModels<TData = Awaited<ReturnType<typeof getVehicleModels>>, TError = ErrorType<null | null | null>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleModels>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehicleModelsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



